const l = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M0 12a12 12 0 1 0 24 0 12 12 0 1 0-24 0"></path></svg>';
export {
  l as default
};
